import { useFetchMixAPi1, useMixApi1Toast, useMxfNestToast } from "hooks";
import { getURLWithParams } from "utils/context";

export const useSetoresList = (params = {}) =>
  useFetchMixAPi1(getURLWithParams("/legislacao/setores", params));

export const useSetorDetail = id =>
  useFetchMixAPi1(id ? `/legislacao/setores/detail/${id}` : null);

// Salvar grava pela mixfiscal-api; Gerar pede o texto à api-mxf e só existe
// com o setor já salvo (o gerador precisa do id).
export const useSetoresToast = (id = null) => {
  const { onSend, isLoading } = useMixApi1Toast();
  const { onSend: onSendNest, isLoading: isGenerating } = useMxfNestToast();

  const onSave = data =>
    onSend({
      endpoint: id
        ? `legislacao/setores/update/${id}`
        : "legislacao/setores/novo",
      type: id ? "PUT" : "POST",
      data,
      messageSuccess: id ? "Setor atualizado" : "Setor cadastrado",
      messageFail: id
        ? "Não foi possível atualizar o Setor"
        : "Não foi possível cadastrar o Setor",
      redirect: !id,
      fieldGetId: "mxf_set_id",
      urlRedirect: "/legislacao/setores/editar",
    });

  const onGeneratePrompt = () =>
    onSendNest({
      endpoint: `/mxf-setores/suggest-prompt-validation/${id}`,
      type: "POST",
      messageSuccess: "Texto gerado com sucesso",
      messageFail: "Não foi possível gerar o texto",
    });

  return {
    onSave,
    onGeneratePrompt: id ? onGeneratePrompt : undefined,
    isLoading,
    isGenerating,
  };
};
